<template>
  <el-button type="danger"
             size="mini"
             @click="onSubmit">
    <slot></slot>
  </el-button>


</template>

<script>

export default {
  components: {},
  props: {
    multipleSelection: Array,
  },
  methods: {
    onSubmit () {
      let multipleIds = {
        'task_ids': this.multipleSelection.map(item => item.taskid),
      }
      if (multipleIds.task_ids.length <= 0) {
        this.$message.error('请至少选择批量删除一个')
        return false
      }
      return request.alert('batchDelete', multipleIds).then((res) => {
        this.$message({
          showClose: true,
          message: '批量删除成功，成功' + res.data.success + '个,共' + multipleIds.task_ids.length + '个',
          type: 'success',
        })
        this.$store.commit('OPEN_LOADING')
        setTimeout(() => {
          this.$emit('clean')
          this.$store.commit('CLOSE_LOADING')
        }, 2000)
      })
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/task/components/buttons/TaskBatchDeleteButton.vue